import { useLazyQuery } from '@apollo/client';
import { Box, Button, CircularProgress, Grid, Modal, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { FIND_ALL_MONITORAMENTOS_ANUNCIO } from '../../../graphql/queries';

const MonitoramentosModal = ({openModal, anuncio, onClose, refetch}) => {
  const [monitoramentos, setMonitoramentos] = useState([]);

  const [loadMonitoramentos, {data: monitoramentosData, loading: monitoramentosLoading}] = useLazyQuery(FIND_ALL_MONITORAMENTOS_ANUNCIO, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (openModal && anuncio?.id) {
      loadMonitoramentos({variables: {anuncioId: anuncio.id}});
    }

    if (!openModal) {
      setMonitoramentos([]);
    }
  }, [openModal, anuncio?.id, loadMonitoramentos]);

  useEffect(() => {
    if (monitoramentosLoading) return;
    setMonitoramentos(monitoramentosData?.monitoramentos || []);
  }, [monitoramentosLoading, monitoramentosData]);

  return (
    <Modal
      open={openModal}
      onClose={() => onClose()}
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      aria-labelledby="server-modal-title"
      aria-describedby="server-modal-description"
      sx={styles.modal}>
      <Box sx={styles.modalBody}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography sx={styles.modalTitle}>Motorista: {anuncio?.motorista?.nome}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography sx={styles.modalSubtitle}>Monitoramentos:</Typography>
            <Grid item sx={styles.modalConent}>
              {monitoramentosLoading ? (
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1}}>
                  <CircularProgress />
                </Box>
              ) : monitoramentos.length === 0 ? (
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1}}>
                  <Typography textAlign={'center'} mt={2} sx={styles.emptyText}>
                    Nenhum monitoramento encontrado para este anúncio.
                  </Typography>
                </Box>
              ) : (
                monitoramentos.map((monitoramento) => (
                  <Box key={monitoramento.id} sx={{display: 'flex', marginBottom: 2, padding: 1, border: '1px solid #ccc', borderRadius: '5px'}}>
                    <Typography sx={styles.optionsText} mr={2}>
                      <b>Início:</b> {new Date(monitoramento.dataInicio).toLocaleString()}
                    </Typography>
                    <Typography sx={styles.optionsText} mr={2}>
                      <b>Fim:</b> {monitoramento.dataFim ? new Date(monitoramento.dataFim).toLocaleString() : 'Em andamento'}
                    </Typography>
                    <Typography sx={{...styles.optionsText, width: '30%'}}>
                      <b>Localizações:</b> {monitoramento.localizacoes.length || '0'}
                    </Typography>
                  </Box>
                ))
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} sx={styles.modalButtonContainer}>
            <Button variant="contained" id="button" onClick={onClose} sx={{width: '185px', margin: '0px 15px'}}>
              Fechar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

const styles = {
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  modalBody: {
    padding: '20px',
    background: '#fff',
    borderRadius: '5px',
    width: '700px',
    maxHeight: '70vh',
    display: 'flex',
    flexDirection: 'column',
  },
  modalTitle: {
    fontWeight: '700',
    fontSize: 13,
    color: '#afafaf',
  },
  modalSubtitle: {
    color: (theme) => theme.palette.paterns.primary,
    fontWeight: '600',
    fontSize: 16,
  },
  optionsText: {
    fontSize: 14,
    color: '#333',
    width: '35%',
  },
  modalConent: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 1,
    marginBottom: 1,
    maxHeight: 'calc(70vh - 250px)',
    minHeight: '300px',
    overflowY: 'auto',
    alignSelf: 'center',
  },
  emptyText: {
    color: (theme) => theme.palette.paterns.blueGray,
  },
};

export default MonitoramentosModal;
